import React from 'react';
import { getUserColor } from '../utils/userHelpers';

const UserProfileHeader = ({ userInfo, isProjectChat, hideAvatar = false }) => {
  if (!isProjectChat || !userInfo || hideAvatar) return null;

  const userColor = getUserColor(userInfo.id);

  return (
    <div className="flex items-center justify-end mb-2">
      <div className="flex items-center mr-2 gap-2">
        <span 
          className="text-[13px] font-medium"
          style={{ color: userColor.hex }}
        >
          {userInfo.name}
        </span>
      </div>
    </div>
  );
};

export default UserProfileHeader; 